<template>
    <div>
        <table style='position: relative' class="table tableBalance">
            <thead>
            <tr>
                <th scope="col">Concepto</th>
                <th scope="col">Ciclo escolar</th>
                <th scope="col">Fuente de movimiento</th>
                <th scope="col">Saldo a favor</th>
            </tr>
            </thead>
            <tbody v-for="(tr, i) in saldoFavor" :key="i">
                <tr class="accordion-toggle collapsed">
                    <td>
                        <p><strong>{{tr.concepto}}</strong></p>
                        
                        <md-menu md-align-trigger>
                            
                            <button md-menu-trigger type="button" class="btn btn-sm" style="background: #F8F9F9 !important; color: #797D7F !important;">
                                Acciones <i class="fas fa-sort-down ml-1"></i>
                            </button>
                            <md-menu-content>
                                <md-menu-item v-if="tr.saldo_a_favor > 0"  @click="activeTransladarSaldos = ! activeTransladarSaldos; selectedRow = tr;">Trasladar saldos</md-menu-item>
                            </md-menu-content>
                        </md-menu>
                    </td>
                    <td>
                        <p>{{tr.ciclo_escolar}}</p>
                    </td>
                    <td>
                        <p>{{tr.fuente_movimiento}}</p>
                    </td>
                    <td>
                        <p><strong>{{tr.saldo_a_favor | currency}}</strong></p>
                    </td>
                </tr>
            </tbody>
        </table>
        <transladar-saldos v-model="activeTransladarSaldos" :cicloEscolares="ciclosEscolares" :cicloEscolar="cicloEscolar" :institucion="institucion" :personaId="personaId" :row="selectedRow" @refreshTable="getRefresh"></transladar-saldos>
    </div>
</template>

<script>
import TransladarSaldos from './modales/mover-saldo.vue'
export default {
    props: [
        'saldoFavor',
        'ciclosEscolares',
        'cicloEscolar',
        'institucion',
        'personaId'
    ],
    data(){
        return{
            activeTransladarSaldos: false,
            selectedRow: []
        }
    },
    components: {
        TransladarSaldos
    },
    methods: {
        getRefresh(){
            this.$emit('refreshTable')

        }
    }
}
</script>